import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ContactUsDto } from '../../models/contact-us.model';
import { superAdminHttpRoutes, superAdminHttpVersion } from '../../consts/super_admin_http_routes';
import { ApiService } from './api.services';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  
     private url: string = superAdminHttpVersion.V1;
  

  constructor(private _httpClient: HttpClient, private apiService: ApiService) {
  }

  async getCountries(): Promise<any[]> {
    const response = await lastValueFrom<any>(
      this.apiService.httpGetCallWithoutParameter(`${this.url}${superAdminHttpRoutes.GET_ALL_COUNTRIES}`)
    );
    return response.data;
  }

  async getStates(country: string): Promise<any[]> {
    const response = await lastValueFrom<any>(
      this.apiService.httpGetCallWithoutParameter(`${this.url}setting/countries/${country}/states`)
    );
    return response.data; 
  }

  async getCities(country: string,state:string): Promise<any[]> {
    const response = await lastValueFrom<any>(
      this.apiService.httpGetCallWithoutParameter(`${this.url}setting/countries/${country}/states/${state}/cities`)
    );
    return response.data; 
  }
  

  async getCertificates(){
    // return await lastValueFrom(this._httpClient.get<any>(`${this.url}/certificates`));

    return await lastValueFrom(this._httpClient.get<any>(`${this.url}${superAdminHttpRoutes.GET_ALL_CERTIFICATES}`));
  }
  async getValidateZip(zip:string){
    return await lastValueFrom(this._httpClient.get<any>(`${this.url}/zip/${zip}/validate`));
  }
  sendContactUs(contactUsDto:ContactUsDto){
    return this.apiService.httpPostCallWithoutToken<any>(`${this.url}setting/contact-us`, contactUsDto);

  }
  syncLessons(productId:string){
    return this._httpClient.post<any>(`${this.url}/sync/products/${productId}/lessons`,null);
  }

}
